import MUIGridContainer from '@mui/material/Grid';
import type { SxProps } from '@mui/material/styles';
import React from 'react';

import { gridMapper } from '~/common/components/PropertyMappers/GridMapper';

type GridProps = React.ComponentProps<typeof MUIGridContainer> & {
  as?: string;
  templateColumns?: string;
  templateRows?: string;
  gap?: string | number;
  sx?: SxProps;
};

const Grid = React.forwardRef<any, GridProps>(({ children, ...props }, ref) => {
  const gridContainerProps = gridMapper(props);

  return (
    <MUIGridContainer container ref={ref} {...gridContainerProps}>
      {children}
    </MUIGridContainer>
  );
});

Grid.displayName = 'Grid';

export default Grid;
